if(!customElements.get('accordion-content')) { 
  class AccordionContent extends HTMLElement {
    static observedAttributes = ["open"];

    constructor() {
      super();

      this.open = this.getAttribute('open') == 'true';

      this.enabled = true;
      this.enableDesktop = this.getAttribute('enable-desktop') == 'true';

      this.elToggle = this.querySelector('[data-toggle]');
      this.elContent = this.querySelector('[data-content]');
      this.elSection = this.closest('[data-accordions-section]');

      this.elToggle.addEventListener('click', this.toggleAccordion.bind(this));

      if(!this.enableDesktop) {
        const enableDisableDesktop = () => {
          let isDesktop = window.matchMedia('(min-width: 1024px)').matches;
          isDesktop ? this.disable() : this.enable();
        }
        window.matchMedia('(min-width: 1024px)').matches && this.disable();
        window.addEventListener('resize', enableDisableDesktop);
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if(newValue == "true") {
        this.open = true;
        this.classList.add('visible');
        setTimeout(() => {
          this.classList.add('open');
          this.elToggle.setAttribute('aria-expanded', true);
          this.elContent.setAttribute('aria-hidden', false);
        }, 50);
      } else {
        this.open = false;
        this.classList.remove('open');
        this.elToggle.setAttribute('aria-expanded', false);
        this.elContent.setAttribute('aria-hidden', true);
        setTimeout(() => {
          this.classList.remove('visible');
        }, 300)
      }
    }

    toggleAccordion() {
      this.setAttribute('open', !this.open);
      if(this.elSection) {
        const { exclusive } = this.elSection.dataset;
        const shouldCloseOtherAccordions = exclusive == 'true';
        const elOtherAccordions = [...this.elSection.querySelectorAll('accordion-content')].filter(el => {
          const { id } = el.querySelector('button');
          return id !== this.elToggle.id;
        });
        
        shouldCloseOtherAccordions && elOtherAccordions.forEach(el => el.setAttribute('open', false));
      }
    }

    disable() {
      this.enabled = false;
      this.elToggle.disabled = true;
      this.setAttribute('open', true);
    }

    enable() {
      this.enabled = true;
      this.elToggle.disabled = false;
      this.setAttribute('open', false);
    }
  }
  customElements.define('accordion-content', AccordionContent);
}